import { ThemePressable, ThemeView } from "@/components/Theme";
import { VIEW_BORDER_RADIUS } from "@/constants/Styles";
import { StyleSheet } from "react-native";
export { default as CardContent } from '@/components/Card/Content';
export { default as CardFooter } from '@/components/Card/Footer';
export { default as CardImage } from '@/components/Card/Image';


export const Card = (props) => {

    const {
        vertical = false,
        light = 'trueGray.100',
        dark = 'trueGray.800',
        bg = null,
        onPress = null,
        solid = false,
        style = {},
        ...rest
    } = props;

    const ContainerComp = !onPress ? ThemeView : ThemePressable;
    
    return (
        <ContainerComp
            onPress={onPress} 
            light={bg ?? light}
            dark={bg ?? dark}
            style={[
                styles.base, 
                (vertical ? styles.containerVertical : styles.container), 
                style,
                solid && {borderRadius: 0}
            ]}
            {...rest}
        />
    );
};

const styles = StyleSheet.create({

    base: {
        borderRadius: VIEW_BORDER_RADIUS,
        overflow: 'hidden',
        //...elements.shadow
    },

    container: {
        
    },  

    containerVertical: {
        
    }

});

export default Card;